<template>
    <div class="container">
        <van-nav-bar :title="mainNo" left-text="" :right-text="rightText" left-arrow @click-left="onClickLeft"
            @click-right="onClickRight">
        </van-nav-bar>

        <van-list v-model="loading" :finished="finished">
            <div class="list-box">
                <div class="list clearfix" :key="index" v-for="(item, index) in allMap">
                    <div class="title">{{ index + 1 }} {{ item[0] }}</div>
                    <div v-for="(innerItem, innerIndex) in item[1].places" :key="innerIndex">
                        <div class="sub-title">{{ index + 1 }}<span>.</span>{{ innerIndex + 1 }} {{ innerItem }}
                        </div>
                        <div class="upImg">
                            <!-- {{ item[1].startIndex + innerIndex }} -->
                            <div class="upImgLoaderView">
                                <div class="statusView" v-if="isUpdate">
                                    <div class="status">
                                        <div>
                                            <van-icon :color="iconColor(allList[item[1].startIndex + innerIndex].status)"
                                                size="30"
                                                :name="iconName(allList[item[1].startIndex + innerIndex].status)" />
                                        </div>
                                        <div :class="statusClass(allList[item[1].startIndex + innerIndex].status)">
                                            {{ statusList[allList[item[1].startIndex + innerIndex].status].name }}
                                        </div>
                                    </div>
                                </div>
                                <van-uploader class="upImgLoader" v-model="imgList[item[1].startIndex + innerIndex]"
                                    :max-count="1" :max-size="10485760"
                                    :before-read="(file) => beforeRead(file, item[1].startIndex + innerIndex)"
                                    :before-delete="() => delImg(item[1].startIndex + innerIndex)"
                                    :deletable="allList[item[1].startIndex + innerIndex].status != 1" />
                            </div>

                            <div class="tips">上传该检查点的现场施工照片</div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>

    </div>
</template>
    
<script>
import axios from '@/axios.js';
import {uploadFiles} from '@/upload.js';
import { NavBar, Icon, Image, Toast, Loading, Picker, Field, Popup, List, Uploader } from 'vant';
import ImageCompressor from 'image-compressor.js' //js图片压缩旋转库
export default {
    data() {
        return {
            imgDomain: 'https://soonsmart.keji.io/',
            loading: false,
            finished: false,
            allList: [],
            allMap: new Map(),
            deviceStatus: undefined,
            rightText: "",

            statusList: [
                { name: '待审核', value: 0 },
                { name: '已通过', value: 1 },
                { name: '未通过', value: 2 },
            ],

            mainNo: "",
            upImgUrl: new Map(),
            imgList: null,

            isUpdate: false,
        };
    },
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Image.name]: Image,
        [Toast.name]: Toast,
        [Loading.name]: Loading,
        [Field.name]: Field,
        [Picker.name]: Picker,
        [Uploader.name]: Uploader,
        [Popup.name]: Popup,
        [List.name]: List
    },
    methods: {
        //0待审核 1审核通过 2审核未通过
        statusClass(status) {
            if (status == 0) {
                return "";
            } else if (status == 1) {
                return "col_g";
            } else if (status == 2) {
                return "col_r";
            }
        },
        iconName(status) {
            if (status == 0) {
                return "";
            } else if (status == 1) {
                return "success";
            } else if (status == 2) {
                return "cross";
            }
        },
        iconColor(status) {
            if (status == 0) {
                return "";
            } else if (status == 1) {
                return "#67C23A";
            } else if (status == 2) {
                return "#F56C6C";
            }
        },

        getAllPlaceList() {
            this.loading = true;
            axios.post("/constructionplace/alllist", { constructionDeviceId: Number(this.$route.query.id) }).then((res) => {
                if (!res.data || res.data.length == 0) {
                    this.isUpdate = false;
                    this.getStandardList();
                } else {
                    this.isUpdate = true;
                    this.allList = res.data.map(item => {
                        return {
                            uploadFiles: item.uploadFiles,
                            status: item.status,
                            typeName: item.typeName,
                            id: item.id,
                            place: item.place,
                        }
                    })
                    this.formatData();
                }
            })
        },
        getStandardList() {
            this.loading = true;
            axios.post("/standard/alllist", { enabled: 1 }).then((res) => {
                this.allList = res.data;

                this.formatData();
            })
        },

        formatData() {
            this.loading = false;
            this.finished = true;

            this.imgList = [];
            this.allMap = new Map();
            this.allList && this.allList.forEach((item, index) => {
                if (item.uploadFiles) {
                    this.imgList.push([{ url: this.imgDomain + item.uploadFiles }]);
                } else {
                    this.imgList.push([]);
                }


                let value = this.allMap.get(item.typeName);
                if (value) {
                    value.places.push(item.place);
                } else {
                    value = {
                        places: [item.place],
                        startIndex: index,//每个类别在列表中的开始索引
                    };
                }
                this.allMap.set(item.typeName, value);
                console.log(this.allMap);
            })
        },

        onClickLeft() {
            this.$router.go(-1);
        },
        onClickRight() {
            if (this.deviceStatus == 1) {
                //已完成
                this.$router.go(-1);
                // this.$router.replace({ path: "constructionDeviceList.html", query: { id: this.$route.query.projectId } });
                return;
            }
            let showTips = true;
            let standards = [];
            this.allList.forEach((item, index) => {
                if (this.upImgUrl.get(item.id)) {
                    showTips = false;
                }
                let standard = {
                    uploadFiles: this.upImgUrl.get(item.id) ? this.upImgUrl.get(item.id) : item.uploadFiles,
                    status: item.status,
                }
                if (this.isUpdate) {
                    standard.id = item.id;
                } else {
                    standard.stantardId = item.id;
                }
                standards.push(standard);
            })
            if (showTips) {
                Toast('至少上传一个检查点的现场施工照片或视频');
                return;
            } else {
                let url = this.isUpdate ? "/constructionplace/batchupdatecreate" : "/constructionplace/batchcreate"
                let params = this.isUpdate ? standards : {
                    constructionDeviceId: Number(this.$route.query.id),
                    standards: standards
                }
                axios.post(url, params).then((res) => {
                    if (res.isSuccess) {
                        Toast('创建成功');
                        this.$router.go(-1);
                        // this.$router.replace({ path: "constructionDeviceList.html", query: { id: this.$route.query.projectId } });
                    }
                });

            }
        },
        beforeRead(file, index) {
            var that = this;
            if (file.length != undefined) {
                Toast('只能选择1张图片');
                return false;
            }
            if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png' && file.type !== 'image/bmp') {
                Toast('请上传 jpg jpeg png bmp 格式图片');
                return false;
            } else if (file.size > 10485760) {
                Toast('请上传不大于 10M 的图片');
                return false;
            } else {
                new ImageCompressor(file, {
                    quality: 0.6, //压缩质量
                    checkOrientation: false,//指示是否读取图像的Exif方向值(仅为JPEG图像)，然后使用该值自动旋转或翻转图像。默认true
                    success(result) {
                        //压缩后的文件会自动转换成二进制文件流类型
                        //这里可以发ajax，上传图片
                        Toast.loading({
                            duration: 0,       // 持续展示 toast
                            forbidClick: true, // 禁用背景点击
                            loadingType: 'spinner',
                            message: '图片上传中...'
                        });
                        that.uprightSuc(result.name, result, index);
                    }
                })
                return true;
            }

        },
        delImg(index) {
            console.log("index" + index + " id: " + this.allList[index].id);
            this.upImgUrl.set(this.allList[index].id, "");
            console.log("delImg upImgUrl>>>>>>>>> ");
            console.log(this.upImgUrl)
            return true;
        },
        uprightSuc(imgName, imgFile, index) {
            let _this = this;
            uploadFiles(imgName, imgFile)         
            .then(function (result) {
                    console.log("index" + index + " id: " + _this.allList[index].id);
                    _this.upImgUrl.set(_this.allList[index].id, result.name);
                    Toast.clear();
                    console.log(_this.upImgUrl);
            })
            .catch(function (err) {
                 console.log('err', err)
            })
        },
    },
    computed: {
    },
    created() {
        this.mainNo = this.$route.query.mainNo;
        this.deviceStatus = this.$route.query.status;
        this.rightText = this.deviceStatus == 1 ? '' : '保存'
        this.getAllPlaceList();
    },
    mounted() { },
    destroyed() { }
}
</script>
<style lang="less" scoped>
body,
html {
    width: 100%;
    height: 100%;
    background: #F0F4F7
}

.container {
    width: 100%;
    height: 100%;
    letter-spacing: 0px;
    background: #F0F4F7;
}

.tips {
    width: 100%;
    color: #c8d1db;
    text-align: center;
}

.list-box {
    width: 100%;
    background: #F0F4F7;

    .list {
        font-size: 14px;
        width: 100%;
        background: #fff;
        padding: 12px;

        .title {
            margin: 0 10px 10px 0;
            font-weight: bold;
        }

        .sub-title {
            margin: 5px 10px;
        }
    }
}

.upImg {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;

    .upImgLoaderView {
        width: 100%;
        display: flex;
        align-items: center;

        .statusView {
            position: absolute;
            float: left;

            .status {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
            }
        }

        .upImgLoader {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

        }
    }

    .van-uploader__upload {
        width: 60px !important;
        height: 60px !important;
    }
}
</style>
    